import { render, staticRenderFns } from "./new-project-task.vue?vue&type=template&id=506f4f68"
import script from "./new-project-task.vue?vue&type=script&lang=js"
export * from "./new-project-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports